const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
const arabicDigits = '٠١٢٣٤٥٦٧٨٩';

export function toEnglishDigits(value = '') {
  return String(value).replace(/[۰-۹٠-٩]/g, (digit) => {
    const persianIndex = persianDigits.indexOf(digit);

    if (persianIndex > -1) {
      return String(persianIndex);
    }

    return String(arabicDigits.indexOf(digit));
  });
}
